// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/@perugi/css-reset/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --text-color: #000000;
  --bg-color: #ffffff;
  --accent-color: #f0f0f0;
  --shadow-color: rgba(0, 0, 0, 0.2);
  --adjacent-color: #d4d4d4;
  --ship-color: #808080;
  --miss-color: #add8e6;
  --hit-color: #db7777;
  --sunk-color: #801c1c;
  --ship-placement-border-color: #90ee90;
  --ship-placement-bg-color: rgba(144, 238, 144, 0.5);
  --modal-bg-color: rgba(0, 0, 0, 0.3);
  --cell-size: 40px;
}

body {
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--text-color);
  font-weight: 700;
}

main {
  flex: auto;
}

header {
  font-family: 'Bebas Neue', serif;
  font-size: clamp(5rem, 20vw, 10rem);
  font-weight: 900;
  margin: 0 auto;

  &.small {
    font-size: 5rem;
  }
}

main {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.content {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}

.gamemode-select-div {
  display: flex;
  margin: 20px;
  justify-content: space-between;

  .gamemode-select {
    font-family: 'Bebas Neue', serif;
    font-size: 2rem;
    text-transform: uppercase;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
    padding: 10px;
    cursor: pointer;
    background-color: transparent;
    border: 3px solid transparent;

    &.active {
      border: 3px solid var(--text-color);
    }

    &:not(.active) {
      box-shadow: none;
    }

    &:hover {
      color: var(--text-color);
    }
  }
}

.player-setup,
.opponent-setup {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;

  input[type='text'] {
    font-size: 1rem;
    text-align: center;
    margin: 10px;
    padding: 10px;
    border: 2px solid var(--text-color);
    border-radius: 2px;
    box-shadow: inset 0 2px 4px var(--shadow-color);
    width: min(100%, 300px);
  }
}

.opponent-setup {
  display: none;
}

.create-players {
  margin-top: 20px;
}

button {
  padding: 0.8em 1.5em;
  cursor: pointer;
  border: 2px solid var(--text-color);
  background-color: var(--bg-color);
  color: var(--text-color);
  box-shadow: 0 2px 4px var(--shadow-color);
  font-weight: 700;

  &:hover {
    background-color: var(--text-color);
    color: var(--bg-color);
  }

  &:active {
    transform: translateY(2px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background-color: var(--bg-color);
      color: var(--text-color);
    }

    &:active {
      transform: none;
    }
  }
}

.game-guidance {
  background-color: var(--accent-color);
  padding: 0.5em 1em;
  margin-bottom: 30px;
}

.ship-placing-area {
  display: flex;

  .unplaced-ships {
    margin-right: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 235px;

    .unplaced-ship {
      margin: 5px 0 5px 0;
      border: 2px solid var(--text-color);
      background-color: var(--shadow-color);
      height: var(--cell-size);
      width: var(--cell-size);

      &.hidden {
        visibility: hidden;
      }
    }
  }
}

.placing-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  gap: 10px;
}

.dragged-ship {
  display: none;
  position: absolute;
  border: 2px solid var(--text-color);
  background-color: var(--shadow-color);
  height: var(--cell-size);
  width: var(--cell-size);

  &.dragging {
    display: block;
  }
}

.gameboards {
  display: flex;
  gap: 40px;

  .player-area,
  .opponent-area {
    display: grid;
    gap: 10px;
    grid-template-columns: auto auto;

    h1 {
      grid-column: 2 / 3;
      grid-row: 1 / 2;
      display: flex;
      justify-content: center;
    }

    .ship-status {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
      position: relative;
      top: calc(var(--cell-size));

      .ship {
        display: flex;
        margin: 3px 0;

        .cell {
          height: calc(var(--cell-size) / 5);
          width: calc(var(--cell-size) / 5);
          background-color: var(--ship-color);
          margin: 1px;
        }

        &.sunk {
          .cell {
            background-color: var(--hit-color);
          }
        }
      }
    }

    .gameboard {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }
  }

  .opponent-area {
    h1 {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }

    .gameboard {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }

    .ship-status {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }
  }

  .player-area.inactive,
  .opponent-area.inactive {
    .ship-status,
    .gameboard {
      opacity: 0.5;
    }
  }
}

.pause-game {
  margin-top: 30px;
}

.pause.modal > .modal-content,
.game-over.modal > .modal-content {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .game-winner,
  .modal-title {
    display: flex;
    justify-content: center;
  }

  .modal-buttons {
    display: flex;
    gap: 10px;
  }
}

.gameboard {
  grid-template-columns: repeat(10, var(--cell-size));
  grid-template-rows: repeat(10, var(--cell-size));
  position: relative;

  .gameboard-row {
    display: flex;
    flex-direction: row;
  }

  .header-cell {
    font-family: 'Bebas Neue', serif;
    font-size: 1.5rem;
    font-weight: 500;
    height: var(--cell-size);
    width: var(--cell-size);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -1px 0 0 -1px;
    user-select: none;
  }

  .gameboard-cell {
    height: var(--cell-size);
    width: var(--cell-size);
    font-size: 1.5rem;
    border: 1px solid var(--text-color);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -1px 0 0 -1px;

    &.adjacent {
      background-color: var(--adjacent-color);
    }

    &.ship {
      background-color: var(--ship-color);
    }

    &.miss {
      background-color: var(--miss-color);

      &::before {
        content: '•';
      }
    }

    &.hit {
      background-color: var(--hit-color);

      &::before {
        content: 'X';
      }
    }

    &.sunk {
      background-color: var(--sunk-color);
    }
  }

  .placed-ship {
    position: absolute;
    border: 2px solid var(--text-color);
    height: calc(var(--cell-size));
    width: calc(var(--cell-size));

    &.hidden {
      display: none;
    }
  }

  .ship-placement-indicator {
    display: none;
    position: absolute;
    height: calc(var(--cell-size));
    width: calc(var(--cell-size));
    border: 2px solid var(--ship-placement-border-color);
    background-color: var(--ship-placement-bg-color);

    &.active {
      display: block;
    }
  }
}

.opponent-area {
  .gameboard-cell {
    &:not(.hit):not(.miss):not(.adjacent):hover::before {
      content: 'X';
    }

    &:not(.hit):not(.miss):not(.adjacent):hover {
      cursor: pointer;
    }
  }
}

.opponent-area {
  .gameboard-cell {
    &.adjacent:not(.hit):not(.miss)::before {
      content: '•';
      color: var(--ship-color);
    }
  }
}

.modal {
  display: none;
  z-index: 2;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--modal-bg-color);
  align-items: center;
  justify-content: center;

  .modal-content {
    z-index: 3;
    background-color: var(--bg-color);
    padding: 16px;
    width: auto;
  }
}

.pass-turn.modal {
  background-color: var(--bg-color);
  display: none;
}

@media (max-width: 1200px) {
  .gameboards {
    flex-direction: column;

    .player-area,
    .opponent-area {
      grid-template-columns: auto 1fr;
      .gameboard {
        grid-column: 1 / 3;
        grid-row: 2 / 3;
      }

      .ship-status {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        top: 0;
      }

      h1 {
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        align-items: center;
      }
    }
  }
}

@media (max-width: 900px) {
  .ship-placing-area {
    flex-direction: column;
    align-items: center;

    .unplaced-ships {
      width: 70%;
      display: flex;
      gap: 10px;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      margin-right: 0;
    }
  }

  .placing-buttons {
    flex-direction: column;
  }
}

footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

#gh-link {
  font-family: 'Bebas Neue', serif;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--text-color);
  letter-spacing: 0;
  display: flex;
  align-items: center;
  margin: 20px 0 10px 0;
  height: 38px;
}

#gh-link > div:first-child {
  width: 130.88px;
  text-align: end;
}

#gh-logo {
  width: 35px;
  height: 35px;
  margin: 0 10px;
  transition: transform 0.3s ease-in-out;
}

#gh-link:hover #gh-logo {
  transform: rotate(360deg) scale(1.2);
}

html {
  visibility: visible;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,sCAAsC;EACtC,mDAAmD;EACnD,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;;EAEd;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;;EAE9B;IACE,gCAAgC;IAChC,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,6BAA6B;;IAE7B;MACE,mCAAmC;IACrC;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;;EAEd;IACE,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,+CAA+C;IAC/C,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mCAAmC;EACnC,iCAAiC;EACjC,wBAAwB;EACxB,yCAAyC;EACzC,gBAAgB;;EAEhB;IACE,mCAAmC;IACnC,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,mBAAmB;;IAEnB;MACE,iCAAiC;MACjC,wBAAwB;IAC1B;;IAEA;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;;EAEb;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;;IAEZ;MACE,mBAAmB;MACnB,mCAAmC;MACnC,qCAAqC;MACrC,wBAAwB;MACxB,uBAAuB;;MAEvB;QACE,kBAAkB;MACpB;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;EACrC,wBAAwB;EACxB,uBAAuB;;EAEvB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;;EAET;;IAEE,aAAa;IACb,SAAS;IACT,gCAAgC;;IAEhC;MACE,kBAAkB;MAClB,eAAe;MACf,aAAa;MACb,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,2BAA2B;;MAE3B;QACE,aAAa;QACb,aAAa;;QAEb;UACE,kCAAkC;UAClC,iCAAiC;UACjC,mCAAmC;UACnC,WAAW;QACb;;QAEA;UACE;YACE,kCAAkC;UACpC;QACF;MACF;IACF;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;;EAEA;;IAEE;;MAEE,YAAY;IACd;EACF;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET;;IAEE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,kBAAkB;;EAElB;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;IACjB,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;;IAErB;MACE,uCAAuC;IACzC;;IAEA;MACE,mCAAmC;IACrC;;IAEA;MACE,mCAAmC;;MAEnC;QACE,YAAY;MACd;IACF;;IAEA;MACE,kCAAkC;;MAElC;QACE,YAAY;MACd;IACF;;IAEA;MACE,mCAAmC;IACrC;EACF;;EAEA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,8BAA8B;IAC9B,6BAA6B;;IAE7B;MACE,aAAa;IACf;EACF;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,6BAA6B;IAC7B,oDAAoD;IACpD,gDAAgD;;IAEhD;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE;IACE;MACE,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE;IACE;MACE,YAAY;MACZ,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,UAAU;IACV,iCAAiC;IACjC,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;;IAEtB;;MAEE,+BAA+B;MAC/B;QACE,kBAAkB;QAClB,eAAe;MACjB;;MAEA;QACE,kBAAkB;QAClB,eAAe;QACf,MAAM;MACR;;MAEA;QACE,kBAAkB;QAClB,eAAe;QACf,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,UAAU;MACV,aAAa;MACb,SAAS;MACT,mBAAmB;MACnB,sBAAsB;MACtB,eAAe;MACf,eAAe;IACjB;EACF;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["@import '../node_modules/@perugi/css-reset/reset.css';\n\n:root {\n  --text-color: #000000;\n  --bg-color: #ffffff;\n  --accent-color: #f0f0f0;\n  --shadow-color: rgba(0, 0, 0, 0.2);\n  --adjacent-color: #d4d4d4;\n  --ship-color: #808080;\n  --miss-color: #add8e6;\n  --hit-color: #db7777;\n  --sunk-color: #801c1c;\n  --ship-placement-border-color: #90ee90;\n  --ship-placement-bg-color: rgba(144, 238, 144, 0.5);\n  --modal-bg-color: rgba(0, 0, 0, 0.3);\n  --cell-size: 40px;\n}\n\nbody {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  color: var(--text-color);\n  font-weight: 700;\n}\n\nmain {\n  flex: auto;\n}\n\nheader {\n  font-family: 'Bebas Neue', serif;\n  font-size: clamp(5rem, 20vw, 10rem);\n  font-weight: 900;\n  margin: 0 auto;\n\n  &.small {\n    font-size: 5rem;\n  }\n}\n\nmain {\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n}\n\n.content {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n}\n\n.gamemode-select-div {\n  display: flex;\n  margin: 20px;\n  justify-content: space-between;\n\n  .gamemode-select {\n    font-family: 'Bebas Neue', serif;\n    font-size: 2rem;\n    text-transform: uppercase;\n    font-weight: 400;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 20px;\n    padding: 10px;\n    cursor: pointer;\n    background-color: transparent;\n    border: 3px solid transparent;\n\n    &.active {\n      border: 3px solid var(--text-color);\n    }\n\n    &:not(.active) {\n      box-shadow: none;\n    }\n\n    &:hover {\n      color: var(--text-color);\n    }\n  }\n}\n\n.player-setup,\n.opponent-setup {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 20px 0;\n\n  input[type='text'] {\n    font-size: 1rem;\n    text-align: center;\n    margin: 10px;\n    padding: 10px;\n    border: 2px solid var(--text-color);\n    border-radius: 2px;\n    box-shadow: inset 0 2px 4px var(--shadow-color);\n    width: min(100%, 300px);\n  }\n}\n\n.opponent-setup {\n  display: none;\n}\n\n.create-players {\n  margin-top: 20px;\n}\n\nbutton {\n  padding: 0.8em 1.5em;\n  cursor: pointer;\n  border: 2px solid var(--text-color);\n  background-color: var(--bg-color);\n  color: var(--text-color);\n  box-shadow: 0 2px 4px var(--shadow-color);\n  font-weight: 700;\n\n  &:hover {\n    background-color: var(--text-color);\n    color: var(--bg-color);\n  }\n\n  &:active {\n    transform: translateY(2px);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    &:hover {\n      background-color: var(--bg-color);\n      color: var(--text-color);\n    }\n\n    &:active {\n      transform: none;\n    }\n  }\n}\n\n.game-guidance {\n  background-color: var(--accent-color);\n  padding: 0.5em 1em;\n  margin-bottom: 30px;\n}\n\n.ship-placing-area {\n  display: flex;\n\n  .unplaced-ships {\n    margin-right: 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 235px;\n\n    .unplaced-ship {\n      margin: 5px 0 5px 0;\n      border: 2px solid var(--text-color);\n      background-color: var(--shadow-color);\n      height: var(--cell-size);\n      width: var(--cell-size);\n\n      &.hidden {\n        visibility: hidden;\n      }\n    }\n  }\n}\n\n.placing-buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n  gap: 10px;\n}\n\n.dragged-ship {\n  display: none;\n  position: absolute;\n  border: 2px solid var(--text-color);\n  background-color: var(--shadow-color);\n  height: var(--cell-size);\n  width: var(--cell-size);\n\n  &.dragging {\n    display: block;\n  }\n}\n\n.gameboards {\n  display: flex;\n  gap: 40px;\n\n  .player-area,\n  .opponent-area {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: auto auto;\n\n    h1 {\n      grid-column: 2 / 3;\n      grid-row: 1 / 2;\n      display: flex;\n      justify-content: center;\n    }\n\n    .ship-status {\n      grid-column: 1 / 2;\n      grid-row: 2 / 3;\n      position: relative;\n      top: calc(var(--cell-size));\n\n      .ship {\n        display: flex;\n        margin: 3px 0;\n\n        .cell {\n          height: calc(var(--cell-size) / 5);\n          width: calc(var(--cell-size) / 5);\n          background-color: var(--ship-color);\n          margin: 1px;\n        }\n\n        &.sunk {\n          .cell {\n            background-color: var(--hit-color);\n          }\n        }\n      }\n    }\n\n    .gameboard {\n      grid-column: 2 / 3;\n      grid-row: 2 / 3;\n    }\n  }\n\n  .opponent-area {\n    h1 {\n      grid-column: 1 / 2;\n      grid-row: 1 / 2;\n    }\n\n    .gameboard {\n      grid-column: 1 / 2;\n      grid-row: 2 / 3;\n    }\n\n    .ship-status {\n      grid-column: 2 / 3;\n      grid-row: 2 / 3;\n    }\n  }\n\n  .player-area.inactive,\n  .opponent-area.inactive {\n    .ship-status,\n    .gameboard {\n      opacity: 0.5;\n    }\n  }\n}\n\n.pause-game {\n  margin-top: 30px;\n}\n\n.pause.modal > .modal-content,\n.game-over.modal > .modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  .game-winner,\n  .modal-title {\n    display: flex;\n    justify-content: center;\n  }\n\n  .modal-buttons {\n    display: flex;\n    gap: 10px;\n  }\n}\n\n.gameboard {\n  grid-template-columns: repeat(10, var(--cell-size));\n  grid-template-rows: repeat(10, var(--cell-size));\n  position: relative;\n\n  .gameboard-row {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .header-cell {\n    font-family: 'Bebas Neue', serif;\n    font-size: 1.5rem;\n    font-weight: 500;\n    height: var(--cell-size);\n    width: var(--cell-size);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: -1px 0 0 -1px;\n    user-select: none;\n  }\n\n  .gameboard-cell {\n    height: var(--cell-size);\n    width: var(--cell-size);\n    font-size: 1.5rem;\n    border: 1px solid var(--text-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: -1px 0 0 -1px;\n\n    &.adjacent {\n      background-color: var(--adjacent-color);\n    }\n\n    &.ship {\n      background-color: var(--ship-color);\n    }\n\n    &.miss {\n      background-color: var(--miss-color);\n\n      &::before {\n        content: '•';\n      }\n    }\n\n    &.hit {\n      background-color: var(--hit-color);\n\n      &::before {\n        content: 'X';\n      }\n    }\n\n    &.sunk {\n      background-color: var(--sunk-color);\n    }\n  }\n\n  .placed-ship {\n    position: absolute;\n    border: 2px solid var(--text-color);\n    height: calc(var(--cell-size));\n    width: calc(var(--cell-size));\n\n    &.hidden {\n      display: none;\n    }\n  }\n\n  .ship-placement-indicator {\n    display: none;\n    position: absolute;\n    height: calc(var(--cell-size));\n    width: calc(var(--cell-size));\n    border: 2px solid var(--ship-placement-border-color);\n    background-color: var(--ship-placement-bg-color);\n\n    &.active {\n      display: block;\n    }\n  }\n}\n\n.opponent-area {\n  .gameboard-cell {\n    &:not(.hit):not(.miss):not(.adjacent):hover::before {\n      content: 'X';\n    }\n\n    &:not(.hit):not(.miss):not(.adjacent):hover {\n      cursor: pointer;\n    }\n  }\n}\n\n.opponent-area {\n  .gameboard-cell {\n    &.adjacent:not(.hit):not(.miss)::before {\n      content: '•';\n      color: var(--ship-color);\n    }\n  }\n}\n\n.modal {\n  display: none;\n  z-index: 2;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--modal-bg-color);\n  align-items: center;\n  justify-content: center;\n\n  .modal-content {\n    z-index: 3;\n    background-color: var(--bg-color);\n    padding: 16px;\n    width: auto;\n  }\n}\n\n.pass-turn.modal {\n  background-color: var(--bg-color);\n  display: none;\n}\n\n@media (max-width: 1200px) {\n  .gameboards {\n    flex-direction: column;\n\n    .player-area,\n    .opponent-area {\n      grid-template-columns: auto 1fr;\n      .gameboard {\n        grid-column: 1 / 3;\n        grid-row: 2 / 3;\n      }\n\n      .ship-status {\n        grid-column: 1 / 2;\n        grid-row: 1 / 2;\n        top: 0;\n      }\n\n      h1 {\n        grid-column: 2 / 3;\n        grid-row: 1 / 2;\n        align-items: center;\n      }\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .ship-placing-area {\n    flex-direction: column;\n    align-items: center;\n\n    .unplaced-ships {\n      width: 70%;\n      display: flex;\n      gap: 10px;\n      flex-direction: row;\n      justify-content: start;\n      flex-wrap: wrap;\n      margin-right: 0;\n    }\n  }\n\n  .placing-buttons {\n    flex-direction: column;\n  }\n}\n\nfooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#gh-link {\n  font-family: 'Bebas Neue', serif;\n  text-decoration: none;\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: var(--text-color);\n  letter-spacing: 0;\n  display: flex;\n  align-items: center;\n  margin: 20px 0 10px 0;\n  height: 38px;\n}\n\n#gh-link > div:first-child {\n  width: 130.88px;\n  text-align: end;\n}\n\n#gh-logo {\n  width: 35px;\n  height: 35px;\n  margin: 0 10px;\n  transition: transform 0.3s ease-in-out;\n}\n\n#gh-link:hover #gh-logo {\n  transform: rotate(360deg) scale(1.2);\n}\n\nhtml {\n  visibility: visible;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
